import Joi from 'joi';

const AddressPreference = Joi.string().allow('');

export default AddressPreference;
